import React, { useState } from 'react';

const defaultSuggestions = [
  'Show me my latest session summary',
  'Create 3 practice problems on fractions',
  'Search summaries for "Differentiation"',
  'Give student feedback',
  'Give tutor feedback',
  'List all my summaries'
];

const Suggestions = ({ onSelect, compact = false }) => {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  return (
    <div className={`lrbrain-suggestions ${compact ? 'compact' : ''}`}>
      <div className="chips">
        {defaultSuggestions.map((suggestion) => (
          <button
            key={suggestion}
            className="chip"
            type="button"
            onClick={() => onSelect(suggestion)}
          >
            {suggestion}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="dismiss"
        onClick={() => setHidden(true)}
        title="Hide suggestions"
        aria-label="Hide suggestions"
      >
        x
      </button>
    </div>
  );
};

export default Suggestions;
